// A dragonfly, modelled facing +X: a slender iridescent body, a big-eyed head
// and four gossamer wings. Ported 1:1 from age-of-mcp's classic dragonfly.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.004, 0.002, 0.06, 5), color: "#1f9e8a",
      position: [-0.01, 0.02, 0], rotation: [0, 0, Math.PI / 2] },     // long abdomen
    { geometry: new THREE.IcosahedronGeometry(0.009, 0), color: "#26b89e",
      position: [0.026, 0.02, 0] },                                  // thorax
    { geometry: new THREE.IcosahedronGeometry(0.009, 0), color: "#101814",
      position: [0.04, 0.022, 0] },                                  // big-eyed head
    // Four wings — flat translucent-looking blades.
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#cfeef0",
      position: [0.024, 0.024, 0.022], scale: [1.6, 0.1, 0.6] },
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#cfeef0",
      position: [0.024, 0.024, -0.022], scale: [1.6, 0.1, 0.6] },
    { geometry: new THREE.IcosahedronGeometry(0.015, 0), color: "#d8f2f4",
      position: [0.006, 0.023, 0.02], scale: [1.5, 0.1, 0.55] },
    { geometry: new THREE.IcosahedronGeometry(0.015, 0), color: "#d8f2f4",
      position: [0.006, 0.023, -0.02], scale: [1.5, 0.1, 0.55] },
  ];
}

export const dragonfly = defineModel({
  id: "dragonfly",
  batchId: "standard",
  name: "Dragonfly",
  tags: ["creature","dragonfly","low-poly","age-of-mcp","classic"],
  summary: "Low-poly dragonfly.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => partsFor(),
  animations: [],
});
